<div class="form-group" *ngFor="let c of items;let idx=index">
   <label for="">{{c.product_name}}</label>
   <input (ngModelChange)="updated()" class="form-control" appNumberOnly [(ngModel)]="subPayments[idx].amount">
</div>
